export default __webpack_public_path__ + "static/media/galliera.3d124943.png";